import React, { useMemo } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.bubble.css';
import { sanitizeQuillHtml } from './sanitizeQuillHtml';

interface ReadOnlyRichTextProps {
  value: string;
  'data-testid'?: string;
}

export const ReadOnlyRichText: React.FC<ReadOnlyRichTextProps> = React.memo(
  function ReadOnlyRichText({ value, 'data-testid': dataTestId }) {
    const sanitized = useMemo(
      () => sanitizeQuillHtml(value, { normalizeSpaces: true }),
      [value],
    );
    return (
      <ReactQuill
        value={sanitized}
        readOnly={true}
        theme="bubble"
        modules={{ toolbar: false }}
        data-testid={dataTestId}
      />
    );
  },
);
